import { OpenFromEnum, RELATIONSHIP_OPTIONS } from '@/constant';
import { ISelectApplicantPopup } from '@/services';
import { allowKorean } from '@/utils';
import { memo, useCallback, useState } from 'react';

import Input from '../form/input';
import Select from '../form/select';

type SelectApplicantRelationshipProps = {
	openFrom?: OpenFromEnum;
	relationshipRefs: React.MutableRefObject<Record<number, string>>;
	record: ISelectApplicantPopup;
};

const SelectApplicantRelationship = ({
	openFrom,
	relationshipRefs,
	record,
}: SelectApplicantRelationshipProps) => {
	const [value, setValue] = useState(record?.lodgingRelationship || '');

	const _onChangeSelect = useCallback((value: string) => {
		setValue(value);
		if (relationshipRefs?.current) relationshipRefs.current[record.id] = value;
	}, []);
	const _onChangeInput = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const _value = allowKorean(e.target.value);
			setValue(_value);
			if (relationshipRefs?.current)
				relationshipRefs.current[record.id] = e.target.value;
		},
		[]
	);

	return (
		<div onClick={(e) => e.stopPropagation()}>
			{openFrom === OpenFromEnum.LM1_03 ? (
				<Select
					value={value}
					onChange={_onChangeSelect}
					options={RELATIONSHIP_OPTIONS}
				/>
			) : (
				<Input
					value={value}
					onChange={_onChangeInput}
					maxLength={10}
					formatInput={allowKorean}
				/>
			)}
		</div>
	);
};

export default memo(SelectApplicantRelationship);
